import React, { useState, useEffect } from 'react';
import Modal from '../common/Modal';
import FeedbackForm from './FeedbackForm';
import SurveyForm from './SurveyForm';
import { getActiveSurvey, hasCompletedSurvey } from '../../services/feedbackService';
import { useAuth } from '../../context/AuthContext';

export default function FeedbackModal({ onClose }) {
  const { user } = useAuth();
  const [survey, setSurvey] = useState(null);
  const [surveyLoading, setSurveyLoading] = useState(true);
  const [showSurvey, setShowSurvey] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function loadSurvey() {
      try {
        const activeSurvey = await getActiveSurvey();
        if (cancelled || !activeSurvey) {
          setSurveyLoading(false);
          return;
        }

        const completed = await hasCompletedSurvey(user.uid, activeSurvey.id);
        if (cancelled) return;

        if (!completed) {
          setSurvey(activeSurvey);
          setShowSurvey(true);
        }
      } catch (error) {
        console.error('Failed to load survey:', error);
      } finally {
        if (!cancelled) setSurveyLoading(false);
      }
    }
    if (user) {
      loadSurvey();
    } else {
      setSurveyLoading(false);
    }
    return () => { cancelled = true; };
  }, [user]);

  const handleSurveySuccess = () => {
    setSurvey(null);
    setShowSurvey(false);
  };

  const handleFeedbackSuccess = () => {
    onClose();
  };

  if (surveyLoading) {
    return (
      <Modal title="Help & Feedback" onClose={onClose}>
        <div className="text-center text-gray-400 py-8">Loading...</div>
      </Modal>
    );
  }

  return (
    <Modal title="Help & Feedback" onClose={onClose}>
      {showSurvey && survey ? (
        <>
          <SurveyForm survey={survey} onSuccess={handleSurveySuccess} />
          <button
            type="button"
            onClick={() => setShowSurvey(false)}
            className="mt-3 text-sm text-gray-500 hover:text-gray-300 transition-colors underline w-full text-center"
          >
            Skip to feedback
          </button>
        </>
      ) : (
        <FeedbackForm onSuccess={handleFeedbackSuccess} />
      )}
    </Modal>
  );
}
